import * as React from "react";
const SvgCameraFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.772 3.684A1 1 0 0 1 8.721 3h6.559a1 1 0 0 1 .948.684L17 6h4a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8", clipRule: "evenodd" }));
export default SvgCameraFill;
